<template>
  <div class="composition-block">
    <template v-if="compositionData.name !== ''">
      <div class="product-name" v-text="compositionData.name" />
      <hr class="medium m-0">
    </template>
    <div class="composition-row">
      <span class="font-weight-bold">
        <template v-if="compositionData.isModifiedFood">
          {{ $t('calorie_base_one_dose') }}
        </template>
        <template v-else>
          {{ $t('calorie_base_daily_dose') }}
        </template>
      </span>
      <span v-text="compositionData.servingSize" />
    </div>
    <div class="composition-row">
      <span v-t="'kaloszlist_adagszama'" class="font-weight-bold" />
      <span v-text="compositionData.serving" />
    </div>
    <hr class="thick m-0">
    <div>
      <div>
        <div class="composition-row d-flex justify-content-between justify-content-between font-weight-bold">
          <span class="ingredient-name" />
          <span v-if="compositionData.isCalorieCheck && (compositionData.calorie !== '' || hasValueInTableDataListColumn('value'))" class="d-flex justify-content-end align-items-center ingredient-amount text-right"><span v-text="compositionData.servingGram" /></span>
          <!-- eslint-disable-next-line vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
          <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('dv')" class="ingredient-dv d-flex align-items-center justify-content-end" v-html="$t('kaloria_ri')" />
          <span v-if="compositionData.isCalorieCheck100 && (compositionData.calorie100 !== '' || hasValueInTableDataListColumn('value100'))" class="d-flex justify-content-end align-items-center ingredient-amount text-right text-no-wrap">100 {{ compositionData.for100Unitname }}</span>
          <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('dv100')" class="flex-wrap ml-2 ingredient-dv d-flex align-items-center justify-content-end text-no-wrap" v-html="$t('kaloria_ri') + ' (100 ' + compositionData.for100Unitname + ')'" />
        </div>
        <hr class="thin m-0">
      </div>
      <template v-if="compositionData.isCalorieCheck || compositionData.isCalorieCheck100">
        <div v-if="!!compositionData.calorie || !!compositionData.calorie100">
          <!--  vastag font, 1. szint  -->
          <div class="composition-row d-flex justify-content-between font-weight-bold">
            <span v-t="'kaloszlist_kaloria'" class="ingredient-name" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck && (compositionData.calorie !== '' || hasValueInTableDataListColumn('value'))" class="ingredient-amount d-flex align-items-center justify-content-end text-right mr-1" v-html="compositionData.calorie" />
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('dv')" class="ingredient-dv text-right" v-text="compositionData.tableDataList.calorie.dv" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck100 && (compositionData.calorie100 !== '' || hasValueInTableDataListColumn('value100'))" class="ingredient-amount d-flex align-items-center justify-content-end text-right mr-1" v-html="compositionData.calorie100" />
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('dv100')" class="ml-2 ingredient-dv text-right" v-text="compositionData.tableDataList.calorie.dv100" />
          </div>
          <hr class="thin m-0">
        </div>
        <div v-if="!!compositionData.tableDataList.fat.value || !!compositionData.tableDataList.fat.value100">
          <!--  vastag font, 1. szint  -->
          <div class="composition-row d-flex justify-content-between font-weight-bold">
            <span v-t="'kaloszlist_zsir'" class="ingredient-name" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('value')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.fat.value" />
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('dv')" class="ingredient-dv text-right" v-text="compositionData.tableDataList.fat.dv" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('value100')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.fat.value100" />
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('dv100')" class="ml-2 ingredient-dv text-right" v-text="compositionData.tableDataList.fat.dv100" />
          </div>
          <hr class="thin m-0">
        </div>
        <div v-if="!!compositionData.tableDataList.fullFat.value || !!compositionData.tableDataList.fullFat.value100">
          <!--  normal font, 2. szint  -->
          <div class="composition-row d-flex justify-content-between">
            <span v-t="'kaloszlist_zsir_telitett'" class="ingredient-name pl-2" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('value')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.fullFat.value" />
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('dv')" class="ingredient-dv text-right" v-text="compositionData.tableDataList.fullFat.dv" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('value100')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.fullFat.value100" />
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('dv100')" class="ml-2 ingredient-dv text-right" v-text="compositionData.tableDataList.fullFat.dv100" />
          </div>
          <hr class="thin m-0">
        </div>
        <div v-if="!!compositionData.tableDataList.fullFatSingle.value || !!compositionData.tableDataList.fullFatSingle.dv || !!compositionData.tableDataList.fullFatSingle.value100">
          <!--  normal font, 2. szint  -->
          <div class="composition-row d-flex justify-content-between">
            <span v-t="'kaloszlist_zsir_egyszeres'" class="ingredient-name pl-2" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('value')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.fullFatSingle.value" />
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('dv')" class="ingredient-dv text-right" v-text="compositionData.tableDataList.fullFatSingle.dv" />
            <!-- eslint-enable vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
            <span
              v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('value100')"
              class="ingredient-amount d-flex align-items-center justify-content-end"
              v-html="compositionData.tableDataList.fullFatSingle.value100"
            />
            <!-- eslint-disable vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('dv100')" class="ml-2 ingredient-dv text-right" v-text="compositionData.tableDataList.fullFatSingle.dv100" />
          </div>
          <hr class="thin m-0">
        </div>
        <div v-if="!!compositionData.tableDataList.fullFatMultiple.value || !!compositionData.tableDataList.fullFatMultiple.dv || !!compositionData.tableDataList.fullFatMultiple.value100">
          <!--  normal font, 2. szint  -->
          <div class="composition-row d-flex justify-content-between">
            <span v-t="'kaloszlist_zsir_tobbszoros'" class="ingredient-name pl-2" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('value')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.fullFatMultiple.value" />
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('dv')" class="ingredient-dv text-right" v-text="compositionData.tableDataList.fullFatMultiple.dv" />
            <!-- eslint-disable vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
            <span
              v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('value100')"
              class="ingredient-amount d-flex align-items-center justify-content-end"
              v-html="compositionData.tableDataList.fullFatMultiple.value100"
            />
            <!-- eslint-enable vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('dv100')" class="ml-2 ingredient-dv text-right" v-text="compositionData.tableDataList.fullFatMultiple.dv100" />
          </div>
          <hr class="thin m-0">
        </div>
        <div v-if="!!compositionData.tableDataList.transFat.value || !!compositionData.tableDataList.transFat.value100">
          <!--  normal font, 2. szint  -->
          <div class="composition-row d-flex justify-content-between">
            <span v-t="'kaloszlist_zsir_transz'" class="ingredient-name pl-2" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('value')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.transFat.value" />
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('dv')" class="ingredient-dv text-right" v-text="compositionData.tableDataList.transFat.dv" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('value100')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.transFat.value100" />
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('dv100')" class="ml-2 ingredient-dv text-right" v-text="compositionData.tableDataList.transFat.dv100" />
          </div>
          <hr class="thin m-0">
        </div>
        <div v-if="!!compositionData.tableDataList.colesterin.value || !!compositionData.tableDataList.colesterin.value100">
          <!--  vastag font, 1. szint  -->
          <div class="composition-row d-flex justify-content-between font-weight-bold">
            <span v-t="'kaloszlist_koleszterin'" class="ingredient-name" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('value')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.colesterin.value" />
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('dv')" class="ingredient-dv text-right" v-text="compositionData.tableDataList.colesterin.dv" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('value100')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.colesterin.value100" />
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('dv100')" class="ml-2 ingredient-dv text-right" v-text="compositionData.tableDataList.colesterin.dv100" />
          </div>
          <hr class="thin m-0">
        </div>
        <div v-if="!!compositionData.tableDataList.kalium.value || !!compositionData.tableDataList.kalium.value100">
          <!--  vastag font, 1. szint  -->
          <div class="composition-row d-flex justify-content-between font-weight-bold">
            <span v-t="'kaloszlist_kalium'" class="ingredient-name" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('value')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.kalium.value" />
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('dv')" class="ingredient-dv text-right" v-text="compositionData.tableDataList.kalium.dv" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('value100')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.kalium.value100" />
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('dv100')" class="ml-2 ingredient-dv text-right" v-text="compositionData.tableDataList.kalium.dv100" />
          </div>
          <hr class="thin m-0">
        </div>
        <div v-if="!!compositionData.tableDataList.carb.value || !!compositionData.tableDataList.carb.value100">
          <!--  vastag font, 1. szint  -->
          <div class="composition-row d-flex justify-content-between font-weight-bold">
            <span v-t="'kaloszlist_szenhidrat'" class="ingredient-name" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('value')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.carb.value" />
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('dv')" class="ingredient-dv text-right" v-text="compositionData.tableDataList.carb.dv" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('value100')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.carb.value100" />
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('dv100')" class="ml-2 ingredient-dv text-right" v-text="compositionData.tableDataList.carb.dv100" />
          </div>
          <hr class="thin m-0">
        </div>
        <div v-if="!!compositionData.tableDataList.carbNet.value || !!compositionData.tableDataList.carbNet.dv || !!compositionData.tableDataList.carbNet.value100">
          <!--  normal font, 2. szint  -->
          <div class="composition-row d-flex justify-content-between">
            <span v-t="'kaloszlist_netto_szenhidrat'" class="ingredient-name pl-2" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('value')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.carbNet.value" />
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('dv')" class="ingredient-dv text-right" v-text="compositionData.tableDataList.carbNet.dv" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('value100')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.carbNet.value100" />
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('dv100')" class="ml-2 ingredient-dv text-right" v-text="compositionData.tableDataList.carbNet.dv100" />
          </div>
          <hr class="thin m-0">
        </div>
        <div v-if="!!compositionData.tableDataList.sugar.value || !!compositionData.tableDataList.sugar.value100">
          <!--  normal font, 2. szint  -->
          <div class="composition-row d-flex justify-content-between">
            <span v-t="'kaloszlist_cukor'" class="ingredient-name pl-2" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('value')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.sugar.value" />
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('dv')" class="ingredient-dv text-right" v-text="compositionData.tableDataList.sugar.dv" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('value100')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.sugar.value100" />
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('dv100')" class="ml-2 ingredient-dv text-right" v-text="compositionData.tableDataList.sugar.dv100" />
          </div>
          <hr class="thin m-0">
        </div>
        <div v-if="!!compositionData.tableDataList.sugarAlcohol.value || !!compositionData.tableDataList.sugarAlcohol.dv || !!compositionData.tableDataList.sugarAlcohol.value100">
          <!--  normal font, 2. szint  -->
          <div class="composition-row d-flex justify-content-between">
            <span v-t="'kaloszlist_cukor_alkohol'" class="ingredient-name pl-2" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('value')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.sugarAlcohol.value" />
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('dv')" class="ingredient-dv text-right" v-text="compositionData.tableDataList.sugarAlcohol.dv" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('value100')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.sugarAlcohol.value100" />
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('dv100')" class="ml-2 ingredient-dv text-right" v-text="compositionData.tableDataList.sugarAlcohol.dv100" />
          </div>
          <hr class="thin m-0">
        </div>
        <div v-if="!!compositionData.tableDataList.fiber.value || !!compositionData.tableDataList.fiber.value100">
          <!--  normal font, 2. szint  -->
          <div class="composition-row d-flex justify-content-between font-weight-bold">
            <span v-t="'kaloszlist_rost'" class="ingredient-name" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('value')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.fiber.value" />
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('dv')" class="ingredient-dv text-right" v-text="compositionData.tableDataList.fiber.dv" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('value100')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.fiber.value100" />
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('dv100')" class="ml-2 ingredient-dv text-right" v-text="compositionData.tableDataList.fiber.dv100" />
          </div>
          <hr class="thin m-0">
        </div>
        <div v-if="!!compositionData.tableDataList.protein.value || !!compositionData.tableDataList.protein.value100">
          <!--  vastag font, 1. szint  -->
          <div class="composition-row d-flex justify-content-between font-weight-bold">
            <span v-t="'kaloszlist_feherje'" class="ingredient-name" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('value')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.protein.value" />
            <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('dv')" class="ingredient-dv text-right" v-text="compositionData.tableDataList.protein.dv" />
            <!-- eslint-disable-next-line vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('value100')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.protein.value100" />
            <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('dv100')" class="ml-2 ingredient-dv text-right" v-text="compositionData.tableDataList.protein.dv100" />
          </div>
          <hr class="thin m-0">
          <div v-if="!!compositionData.tableDataList.natrium.value || !!compositionData.tableDataList.natrium.value100">
            <!--  vastag font, 1. szint  -->
            <div class="composition-row d-flex justify-content-between font-weight-bold">
              <span v-t="'kaloszlist_natrium'" class="ingredient-name" />
              <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> vagy akár még <br> is... -->
              <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('value')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.natrium.value" />
              <span v-if="compositionData.isCalorieCheck && hasValueInTableDataListColumn('dv')" class="ingredient-dv text-right" v-text="compositionData.tableDataList.natrium.dv" />
              <!-- eslint-disable-next-line vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
              <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('value100')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="compositionData.tableDataList.natrium.value100" />
              <span v-if="compositionData.isCalorieCheck100 && hasValueInTableDataListColumn('dv100')" class="ml-2 ingredient-dv text-right" v-text="compositionData.tableDataList.natrium.dv100" />
            </div>
          </div>
        </div>
      </template>
      <hr v-if="compositionData.ingredientList.length !== 0 && hasValueInTableDataList()" class="thick m-0">
      <!--  normal font, 2. szint  -->
      <div v-if="compositionData.ingredientList.length !== 0 && compositionData.showVitaminHeader" class="composition-row d-flex justify-content-between font-weight-bold">
        <span class="ingredient-name">
          <template v-if="compositionData.isModifiedFood">
            {{ $t('calorie_base_other_ingredients') }}
          </template>
          <template v-else>
            {{ $t('calorie_base_active_ingredients') }}
          </template>
        </span>
        <template v-if="hasValueInIngredientListColumn('amount')">
          <span v-if="!!compositionData.servingGram" class="align-items-center d-flex justify-content-end ingredient-amount text-right"><span v-text="compositionData.servingGram" /></span>
          <span v-else class="align-items-center d-flex justify-content-end ingredient-amount text-right" v-text="compositionData.servingSize" />
        </template>
        <!-- eslint-disable vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
        <span
          v-if="(!!compositionData.servingGram || !!compositionData.servingSize) && hasValueInIngredientListColumn('rda')"
          class="ingredient-dv d-flex align-items-center justify-content-end"
          v-html="$t('kaloria_nrv')"
        />
        <span v-if="compositionData.ingredientsIn100g && hasValueInIngredientListColumn('amount100')" class="align-items-center d-flex justify-content-end ingredient-amount text-right text-no-wrap">100 {{ compositionData.for100Unitname }}</span>
        <span
          v-if="compositionData.ingredientsIn100g && hasValueInIngredientListColumn('rda100')"
          class="flex-wrap ml-2 ingredient-dv d-flex align-items-center justify-content-end text-no-wrap"
          v-html="$t('kaloria_nrv') + ' (100 ' + compositionData.for100Unitname + ')'"
        />
        <!-- eslint-enable vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
      </div>

      <hr v-if="compositionData.ingredientList.length !== 0" class="medium m-0">

      <div
        v-for="(ingredient, ingredientIndex) in compositionData.ingredientList"
        :key="'ingredient_' + ingredientIndex"
        class="composition-row d-flex justify-content-between"
      >
        <span class="ingredient-name" v-html="ingredient.name" />
        <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> vagy akár még <br> is... -->
        <span v-if="hasValueInIngredientListColumn('amount')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="ingredient.amount" />
        <span v-if="hasValueInIngredientListColumn('rda')" class="ingredient-dv text-right" v-html="ingredient.rda" />
        <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> <sup> vagy akár még <br> is... -->
        <span v-if="compositionData.ingredientsIn100g && hasValueInIngredientListColumn('amount100')" class="ingredient-amount d-flex align-items-center justify-content-end" v-html="ingredient.amount100" />
        <span v-if="compositionData.ingredientsIn100g && hasValueInIngredientListColumn('rda100')" class="ml-2 ingredient-dv text-right" v-html="ingredient.rda100" />
      </div>

      <hr
        v-if="compositionData.comment !== '' || compositionData.description !== '' || compositionData.isCalorieCheck || compositionData.ingredientList.length !== 0"
        class="thick m-0"
      >

      <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> <sup> vagy akár még <br> is... -->
      <div v-if="compositionData.isCalorieCheck && (compositionData.showRIDescription || compositionData.showRINote)" class="comment bottom-text-block">
        <span v-if="compositionData.showRIDescription" v-html="$t('kaloria_ri_description')" />
        <br v-if="compositionData.showRIDescription && compositionData.showRINote">
        <span v-if="compositionData.showRINote" v-html="$t('kaloria_ri_description_note')" />
      </div>

      <!-- eslint-disable-next-line vue/no-v-html értékben lehet <strong> <b> <sup> vagy akár még <br> is... -->
      <div v-if="compositionData.ingredientList.length !== 0 && (compositionData.showNRVDescription || compositionData.showNRVNote)" class="comment bottom-text-block">
        <span v-if="compositionData.showNRVDescription" v-html="$t('kaloria_nrv_description')" />
        <br v-if="compositionData.showNRVDescription && compositionData.showNRVNote">
        <span v-if="compositionData.showNRVNote" v-html="$t('kaloria_nrv_description_note')" />
      </div>

      <!-- eslint-disable vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
      <div
        v-if="compositionData.description !== ''"
        class="description bottom-text-block"
        v-html="compositionData.description"
      />
      <div
        v-if="compositionData.comment !== ''"
        class="comment bottom-text-block"
        v-html="compositionData.comment"
      />
      <!-- eslint-enable vue/no-v-html értékben lehet <b> <sup> vagy akár még <br> is... -->
    </div>
  </div>
</template>

<script>

/**
 * supplement fact táblázat
 */
export default {
  name: 'Composition',
  props: {
    /**
     * charthoz szükséges adat object
     *
     * @type {
     *     {
     *       calorie: String,
     *       calorieFat: String,
     *       tableDataList: [
     *         carb: {
     *           dv: String,
     *           value: String,
     *         },
     *         carbNet: {
     *           dv: String,
     *           value: String,
     *         },
     *         colesterin: {
     *           dv: String,
     *           value: String,
     *         },
     *         fat: {
     *           dv: String,
     *           value: String,
     *         },
     *         fiber: {
     *           dv: String,
     *           value: String,
     *         },
     *         fullFat: {
     *           dv: String,
     *           value: String,
     *         },
     *         fullFatMultiple: {
     *           dv: String,
     *           value: String,
     *         },
     *         fullFatSingle: {
     *           dv: String,
     *           value: String,
     *         },
     *         kalium: {
     *           dv: String,
     *           value: String,
     *         },
     *         natrium: {
     *           dv: String,
     *           value: String,
     *         },
     *         protein: {
     *           dv: String,
     *           value: String,
     *         },
     *         sugar: {
     *           dv: String,
     *           value: String,
     *         },
     *         sugarAlcohol: {
     *           dv: String,
     *           value: String,
     *         },
     *         transFat: {
     *           dv: String,
     *           value: String,
     *         },
     *       ],
     *       comment: String,
     *       description: String,
     *       ingredientList: [
     *         {
     *           amount: String,
     *           name: String,
     *           rda: String,
     *         },
     *       ],
     *       isCalorieCheck: Boolean,
     *       isModifiedFood: Boolean,
     *       name: String,
     *       nameWithoutBrand: String,
     *       serving: String,
     *       servingSize: String,
     *     }}
     */
    compositionData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    hasValueInTableDataListColumn(column) {
      let hasValue = false
      Object.keys(this.compositionData.tableDataList).forEach(key => {
        if (this.compositionData.tableDataList[key][column].trim() !== '') {
          hasValue = true
        }
      })
      return hasValue
    },
    /**
     * van-e bármilyen adat a table data listen
     *
     * @returns {boolean}
     */
    hasValueInTableDataList() {
      return this.hasValueInTableDataListColumn('value') ||
        this.hasValueInTableDataListColumn('dv') ||
        this.hasValueInTableDataListColumn('value100') ||
        this.hasValueInTableDataListColumn('dv100') ||
        this.compositionData.calorie !== '' ||
        this.compositionData.calorie100 !== ''
    },
    hasValueInIngredientListColumn(column) {
      let hasValue = false
      this.compositionData.ingredientList.forEach(item => {
        if (item[column].trim() !== '') {
          hasValue = true
        }
      })
      return hasValue
    },
  },
}
</script>

<style scoped lang="scss">
.composition-block {
  max-width: calc(min(85vw, 374px));
  border: 1px solid #000;
  padding: 5px;

  .product-name {
    text-align: center;
    color: #000;
    font-size: 20px;
    font-weight: 700;
  }

  .title {
    font-size: 13px;
  }

  .composition-row {
    line-height: 19px;

    .text-no-wrap {
      white-space: nowrap;
    }

    span {
      font-size: 12px;
    }

    .ingredient-dv {
      width: 17%;
    }

    .ingredient-amount {
      width: 28%;
    }

    .ingredient-name {
      width: 55%;
    }
  }

  .composition-row + .composition-row {
    border-top: 1px solid #c1c3d1;
  }

  .comment,
  .description {
    font-size: 12px;

    p {
      font-size: 12px !important;
    }
  }

  .bottom-text-block {
    padding-top: .25rem;
  }

  .bottom-text-block + .bottom-text-block {
    border-top: 1px solid #c1c3d1;
    margin-top: .5rem;
    padding-top: .5rem;
  }

  hr {
    background-color: #000;
    border-top: 1px solid #C1C3D1;
    border-bottom: 1px solid #C1C3D1;

    &.thin {
      height: 1px;
    }

    &.medium {
      height: 3px;
    }

    &.thick {
      height: 8px;
    }
  }
}

::v-deep .textpici {
  font-size: 10px;
  line-height: 13px;
  display: block;
  border-left: 2px solid #800;
  padding-left: 5px;
}
</style>
